// extracted by mini-css-extract-plugin
module.exports = {"fareHeadingItem__serviceClass":"fareHeadingItem__serviceClass-1kL77"};